/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Interakcje macierzy par: wybor liczby, legenda, sticky naglowki.
   Nie liczy statystyk — czyta tylko to, co pary.html.twig juz wyrenderowal. */
(function () {
    'use strict';

    var tabela = document.querySelector('[data-pairs-matrix]');
    var wrap   = document.querySelector('[data-pairs-matrix-wrap]');
    if (!tabela || !wrap || document.querySelector('[data-pairs-tools]')) return;

    var en = (document.documentElement.lang || 'pl').toLowerCase().indexOf('en') === 0;
    var t = en ? {
        etykieta: jst("ui.abdc167240ffaa69"), wszystkie: jst("ui.a52ace420f2175d0"), wyczysc: jst("ui.cea4d2e010b8fd52"),
        wybierz: jst("ui.e291deaaee01c0bd"), wybrano: jst("ui.1cb7f588dd8d909d"),
        wyczyszczono: jst("ui.cad6acf5ea614c63"),
        leg_count: jst("ui.b9bce785af8edb83"),
        leg_diff: jst("ui.14cdf760db7779af"),
        leg_brak: jst("ui.7b07024335b7a551"),
        leg_pusto: jst("ui.fff4cd898cbc7bdd")
    } : {
        etykieta: jst("pages_pary_interakcje_js.literal.e22c8239ffea"), wszystkie: jst("ui.11366eeda2682659"), wyczysc: jst("pages_pary_interakcje_js.literal.647bb8c0ba34"),
        wybierz: jst("pages_pary_interakcje_js.literal.2fa5bd125fd6"), wybrano: jst("pages_pary_interakcje_js.literal.4555ae2093bf"),
        wyczyszczono: jst("pages_pary_interakcje_js.literal.2df06aa0df60"),
        leg_count: jst("pages_pary_interakcje_js.literal.d9703d5fcda8"),
        leg_diff: jst("pages_pary_interakcje_js.literal.802dc4c78f40"),
        leg_brak: jst("pages_pary_interakcje_js.literal.eb0e091d2b5e"),
        leg_pusto: jst("ui.0d95c2d45b1ab3cb")
    };

    var akcje  = document.querySelector('[data-pairs-matrix-actions]');
    var wybor  = 0;
    var tryb   = trybAktywny() || 'count';
    var tymcz  = [];
    var ui     = zbudujPanel();

    function tpl(s, m) { return s.replace(/\{(\w+)\}/g, function (_, k) { return m[k]; }); }
    function numer(th) { var n = parseInt(th && th.textContent, 10); return n > 0 ? n : 0; }
    /* Lewy naglowek # nie jest kolumna danych. Zwracamy tylko numerowane
       naglowki, zeby indeks td[j] zawsze odpowiadal kolumnie kol[j]. */
    function naglowkiKol() {
        var all = tabela.querySelectorAll('thead th[scope="col"]'), out = [];
        for (var i = 0; i < all.length; i++) {
            if (numer(all[i])) out.push(all[i]);
        }
        return out;
    }
    function wiersze() { return tabela.querySelectorAll('tbody tr'); }

    function trybAktywny() {
        var b = document.querySelector('[data-pairs-mode][aria-pressed="true"]')
            || document.querySelector('[data-pairs-mode].aktywny');
        return b ? b.getAttribute('data-pairs-mode') : null;
    }

    function formatuj(v) {
        var s = Number.isInteger(v) ? String(v) : v.toFixed(2);
        return en ? s : s.replace('.', ',');
    }

    function zbudujPanel() {
        var panel = document.createElement('div');
        panel.className = 'grupa odstep-1';
        panel.setAttribute('data-pairs-tools', '');

        var lab = document.createElement('label');
        lab.className = 'etykieta';
        lab.htmlFor = 'pary-liczba';
        lab.textContent = t.etykieta;

        var sel = document.createElement('select');
        sel.className = 'pole';
        sel.id = 'pary-liczba';
        sel.setAttribute('data-pairs-number', '');
        var opt = document.createElement('option');
        opt.value = '0';
        opt.textContent = t.wszystkie;
        sel.appendChild(opt);
        var kol = naglowkiKol();
        for (var i = 0; i < kol.length; i++) {
            var n = numer(kol[i]) || (i + 1);
            var o = document.createElement('option');
            o.value = String(n);
            o.textContent = String(n);
            sel.appendChild(o);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'przycisk przycisk--drugi przycisk--maly';
        btn.setAttribute('data-pairs-clear', '');
        btn.textContent = t.wyczysc;

        var leg = document.createElement('p');
        leg.className = 'tekst-maly';
        leg.setAttribute('data-pairs-legend', '');

        var stat = document.createElement('p');
        stat.className = 'tekst-maly';
        stat.setAttribute('data-pairs-status', '');
        stat.setAttribute('aria-live', 'polite');

        panel.appendChild(lab); panel.appendChild(sel); panel.appendChild(btn);
        panel.appendChild(leg); panel.appendChild(stat);
        if (akcje && akcje.parentNode) akcje.insertAdjacentElement('afterend', panel);
        else wrap.parentNode.insertBefore(panel, wrap);
        return { sel: sel, leg: leg, stat: stat };
    }



    function przypnijNaglowki() {
        var ths = tabela.querySelectorAll('th[scope="row"], th[scope="col"]');
        for (var i = 0; i < ths.length; i++) {
            var n = numer(ths[i]);
            if (!n || ths[i].hasAttribute('tabindex')) continue;
            ths[i].setAttribute('tabindex', '0');
            ths[i].setAttribute('title', t.wybierz + n);
        }
    }

    function zastosujWybor() {
        var kol = naglowkiKol(), kolNum = [], i, j;
        for (i = 0; i < kol.length; i++) {
            kolNum[i] = numer(kol[i]);
            kol[i].toggleAttribute('data-pairs-active', wybor > 0 && kolNum[i] === wybor);
        }
        var rzedy = wiersze(), trafione = 0;
        for (i = 0; i < rzedy.length; i++) {
            var th = rzedy[i].querySelector('th[scope="row"]');
            var a = numer(th);
            if (th) th.toggleAttribute('data-pairs-active', wybor > 0 && a === wybor);
            var td = rzedy[i].querySelectorAll('td');
            for (j = 0; j < td.length; j++) {
                var w = wybor > 0 && a !== wybor && kolNum[j] !== wybor;
                td[j].toggleAttribute('data-pairs-dim', w);
                if (wybor > 0 && !w && td[j].querySelector('[data-pair-cell]')) trafione++;
            }
        }
        ui.stat.textContent = wybor > 0 ? tpl(t.wybrano, { n: wybor, k: trafione }) : t.wyczyszczono;
    }

    function ustawWybor(n) {
        wybor = n > 0 ? n : 0;
        if (ui.sel.value !== String(wybor)) ui.sel.value = String(wybor);
        zastosujWybor();
    }

    function odswiezLegende() {
        var cele = tabela.querySelectorAll('[data-pair-cell]');
        var attr = tryb === 'diff' ? 'data-diff' : 'data-count';
        var min = Infinity, max = -Infinity;
        for (var i = 0; i < cele.length; i++) {
            var raw = cele[i].getAttribute(attr);
            if (raw === null || raw === '') continue;
            var v = Number(raw);
            if (isNaN(v)) continue;
            if (v < min) min = v;
            if (v > max) max = v;
        }
        if (!cele.length) { ui.leg.textContent = t.leg_pusto; return; }
        if (min === Infinity) { ui.leg.textContent = tryb === 'diff' ? t.leg_brak : t.leg_pusto; return; }
        ui.leg.textContent = tpl(tryb === 'diff' ? t.leg_diff : t.leg_count, { min: formatuj(min), max: formatuj(max) });
    }

    /* Tymczasowe wyroznienie wiersza i kolumny komorki — nie rusza `wybor`. */
    function czyscTymczasowe() {
        for (var i = 0; i < tymcz.length; i++) {
            tymcz[i].removeAttribute('data-pairs-row-hl');
            tymcz[i].removeAttribute('data-pairs-col-hl');
        }
        tymcz = [];
    }

    function podswietlKomorke(td) {
        czyscTymczasowe();
        if (!td) return;
        var tr = td.parentNode;
        var idx = Array.prototype.indexOf.call(tr.querySelectorAll('td'), td);
        tr.setAttribute('data-pairs-row-hl', ''); tymcz.push(tr);
        var kol = naglowkiKol()[idx];
        if (kol) { kol.setAttribute('data-pairs-col-hl', ''); tymcz.push(kol); }
        var rzedy = wiersze();
        for (var i = 0; i < rzedy.length; i++) {
            var c = rzedy[i].querySelectorAll('td')[idx];
            if (c) { c.setAttribute('data-pairs-col-hl', ''); tymcz.push(c); }
        }
    }

    function komorkaZ(el) {
        var td = el && el.closest ? el.closest('td') : null;
        return td && tabela.contains(td) && td.closest('tbody') ? td : null;
    }

    function odswiezWszystko() {
        czyscTymczasowe();
        przypnijNaglowki();
        zastosujWybor();
        odswiezLegende();
    }

    function naglowekZ(el) {
        var th = el && el.closest ? el.closest('th[scope="row"], th[scope="col"]') : null;
        return th && tabela.contains(th) && numer(th) ? th : null;
    }

    function podlaczZdarzenia() {
        ui.sel.addEventListener('change', function () { ustawWybor(parseInt(ui.sel.value, 10)); });
        document.querySelector('[data-pairs-clear]').addEventListener('click', function () { ustawWybor(0); });

        tabela.addEventListener('click', function (e) {
            if (e.target.closest('[data-pair-cell]')) return;
            var th = naglowekZ(e.target);
            if (th) ustawWybor(numer(th));
        });
        tabela.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            var th = naglowekZ(e.target);
            if (th) { e.preventDefault(); ustawWybor(numer(th)); }
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && wybor) ustawWybor(0);
        });

        tabela.addEventListener('mouseover', function (e) { var td = komorkaZ(e.target); if (td && td !== tymcz[0]) podswietlKomorke(td); });
        tabela.addEventListener('mouseleave', czyscTymczasowe);
        tabela.addEventListener('focusin', function (e) { var td = komorkaZ(e.target); if (td) podswietlKomorke(td); });
        tabela.addEventListener('focusout', function (e) { if (!komorkaZ(e.relatedTarget)) czyscTymczasowe(); });

        if (akcje) akcje.addEventListener('click', function (e) {
            var b = e.target.closest('[data-pairs-mode]');
            if (!b) return;
            tryb = b.getAttribute('data-pairs-mode') || tryb;
            setTimeout(odswiezLegende, 0); // po handlerze pary.html.twig, ktory przepisuje komorki
        });

        /* Jeden obserwator: wymiana tbody przy zmianie zakresu, zbita do jednej klatki. */
        var czeka = false;
        new MutationObserver(function () {
            if (czeka) return;
            czeka = true;
            requestAnimationFrame(function () { czeka = false; odswiezWszystko(); });
        }).observe(tabela, { childList: true, subtree: true });
    }


    podlaczZdarzenia();
    odswiezWszystko();
    ui.stat.textContent = '';
})();
